function swishBtn() {
  const swishButtons = $(".swish-button");
  const qrCode = $(".qr-code");
  const closeQrCode = $(".qr-code__close");

  swishButtons.each(function () {
    $(this).on("click", function (event) {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
      } else {
        event.preventDefault();
        qrCode.toggleClass("hidden");
      }
    });
  });

  closeQrCode.on("click", function () {
    qrCode.toggleClass("hidden");
  });
}

export default swishBtn;
